import { render, staticRenderFns } from "./tbbj.vue?vue&type=template&id=eb4c58b4&scoped=true&"
import script from "./tbbj.vue?vue&type=script&lang=js&"
export * from "./tbbj.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb4c58b4",
  null
  
)

export default component.exports